import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClassicLoginMutation, useGetClassicLoginPageMutation } from '../../features/authentication/authApiSlice';
import { setCredentials } from '../../features/authentication/authSlice';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

export default function Index() {
  const navigate = useNavigate();
  const [classicLogin] = useClassicLoginMutation();
  const dispatch = useDispatch();
  const { session, user, lastAccess, redirectPage, logId, signedInAsId, sso } = useParams();
  const [getClassicLoginQuery] = useGetClassicLoginPageMutation();
  useEffect(() => {


    if (session && user && lastAccess && redirectPage) {
      (async () => {
        try {
          const authResponse = await classicLogin({
            UserToken: user,
            AspSessionId: session,
            LastAccess: lastAccess,
            SiteSwitchLogId: logId,
            SignedInAsId: signedInAsId,
            ssoType: sso
          }).unwrap();
          dispatch(
            setCredentials({
              accessToken: authResponse.accessToken
            })
          );

          navigate(redirectPage);
          localStorage.removeItem('classes');

        } catch (ex) {
          console.log(ex);
          //navigate('/login');
          getClassicLoginQuery().then((response) => {
            window.location.href = response.data;
          });
        }
      })();
    } else {
      getClassicLoginQuery().then((response) => {
        window.location.href = response.data;
      });

    }
  }, []);

  return (
    <>Redirecting...</>
  );
}